module.exports = __webpack_public_path__ + "media/images/icons/gf-query_stats-rounded-4657db64d6c1019aa15d00d586dcff00.svg";